import $ from 'jquery'
import includes from 'lodash/includes'

import '../../../scss/app/appointment.scss'

const $serviceType = $('[data-field="skylineOrCarolinaWest"]').find('input')
const $skylineServices = $('.skyline-svc')
const $cwwServices = $('.cww-svc')
const $comments = $('.svc-comments')

function hideFormGroup($group) {
  $group.hide().find('input, select, textarea').attr('disabled', 'disabled')
}

function showFormGroup($group) {
  $group.show().find('input, select, textarea').removeAttr('disabled')
}

hideFormGroup($skylineServices)
hideFormGroup($cwwServices)
hideFormGroup($comments)

function updateServices() {
  const selected = $serviceType.filter(':checked').val()

  if (selected === 'SkyLine/SkyBest') {
    hideFormGroup($cwwServices)
    showFormGroup($skylineServices)
  } else if (selected === 'CWW') {
    hideFormGroup($skylineServices)
    showFormGroup($cwwServices)
  }
}

updateServices()
$serviceType.on('click', updateServices)

function updateComments() {
  const selected = $serviceType.filter(':checked').val()
  const chosenSkylineServices = $skylineServices.find('input:checked').map((_, input) => input.value)
  const chosenCwwService = $cwwServices.find('input:checked').val()

  if (selected === 'SkyLine/SkyBest' && includes(chosenSkylineServices, 'Other')) {
    showFormGroup($comments)
  } else if (selected === 'CWW' && chosenCwwService === 'Other') {
    showFormGroup($comments)
  } else {
    hideFormGroup($comments)
  }
}

updateComments()
$serviceType.on('click', updateComments)
$skylineServices.find('input').click(updateComments)
$cwwServices.find('input').click(updateComments)
